export default __webpack_public_path__ + "static/media/das.706e41e5.png";